import type { RouteRecordRaw } from "vue-router";
import SiteHome from "@/views/site-home/index.vue";

/**
 * 静态路由
 */
export const routes: Array<RouteRecordRaw> = [
  {
    path: "/:path(.*)*",
    component: () => import("@/views/exception/404/index.vue"),
  },
  {
    path: "/",
    component: SiteHome,
  },
  {
    path: "/site-search",
    component: () => import("@/views/site-search/index.vue"),
  },
  {
    path: "/bultin-detail/:id",
    name: "bultinDetail",
    component: () => import("@/views/site-detail/index.vue"),
  },
  {
    path: "/site-news/:id",
    name: "SiteNews",
    component: () => import("@/views/site-news/index.vue"),
  },
  {
    path: "/site-statute",
    name: "SiteStatute",
    component: () => import("@/views/site-statute/index.vue"),
  },
  {
    path: "/site-info",
    name: "SiteInfo",
    component: () => import("@/views/site-info/index.vue"),
  },
  {
    path: "/help-center",
    name: "HelpCenter",
    component: () => import("@/views/help-center/index.vue"),
  },
  {
    path: "/common-problem",
    name: "CommonProblem",
    component: () => import("@/views/help-center/common-problem/index.vue"),
  },
];
